import { http } from 'src/utils/http.util'
import type {
  EHumanReviewRequestSubject,
  EHumanReviewResolution,
  THumanReviewDetail,
  THumanReviewListPayload,
  THumanReviewListResponse,
  THumanReviewRequest,
  THumanReviewTab,
} from 'src/pages/dashboard/_components/human-review-requests.type'

export const HumanReviewRequestsService = {
  getTabs: (projectId: number): Promise<{ tabs: THumanReviewTab[] }> => {
    return http.get(`/projects/${projectId}/human-review-requests/tabs`).then((res) => res.data)
  },

  getList: (projectId: number, payload: THumanReviewListPayload): Promise<THumanReviewListResponse> => {
    return http.post(`/projects/${projectId}/human-review-requests/list`, payload).then((res) => res.data)
  },

  getDetail: (projectId: number, patientMedEventId: number): Promise<THumanReviewDetail> => {
    return http
      .get(`/projects/${projectId}/human-review-requests/${patientMedEventId}`)
      .then((res) => res.data)
  },

  resolve: (
    projectId: number,
    humanReviewRequestId: number,
    payload: { resolution: EHumanReviewResolution; resolutionComment: string },
  ): Promise<THumanReviewRequest> =>
    http
      .patch(`/projects/${projectId}/human-review-requests/${humanReviewRequestId}/resolve`, payload)
      .then((res) => res.data),

  resolveBySubject: (
    projectId: number,
    payload: {
      patientMedEventId: number
      subject: EHumanReviewRequestSubject
      resolution: EHumanReviewResolution
      resolutionComment?: string
    },
  ): Promise<void> =>
    http
      .post(`/projects/${projectId}/human-review-requests/resolve-by-subject`, payload)
      .then((res) => res.data),
}
